<template lang="pug">
  .h-100
    button.video-controller__button(
      type="button",
      :data-index="dataIndex",
      @click="toggleTextChat",
      @mouseenter="onMouseEnter",
      @mouseleave="onMouseLeave"
    )
      img.video-controller__icon(src="/static/img/app/btn-chat.svg")
    span.text-nowrap.video-controller__tooltip
      | {{ tooltip }}
</template>

<script>
export default {
  name: 'ChatButton',
  props: [
    'onMouseEnter',
    'onMouseLeave',
    'dataIndex'
  ],
  data () {
    return {
      flag: false,
      toggleText: {
        true: 'チャットを非表示',
        false: 'チャットを表示'
      }
    }
  },
  computed: {
    tooltip: {
      get () {
        return this.toggleText[String(this.$store.state.showTextChat)]
      },
      set () {
        this.flag = this.$store.state.showTextChat
      }
    }
  },
  mounted () {
    this.flag = this.$store.state.showTextChat
  },
  methods: {
    toggleTextChat () {
      this.flag = !this.$store.state.showTextChat
      this.$store.dispatch('updateShowTextChat', { flag: this.flag })
    }
  }
}
</script>
